"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useState } from "react";
import { usePersistSessionState } from "@shared-utils/hooks/session/use-persist-session-state";
import { LAST_VISITED_URL_KEY } from "@shared-utils/hooks/session/cookie-anchor";
import { api } from "@shared-server/api";
export function SessionStatePersister() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AccountSessionStateProvider><SessionStatePersisterInner /></AccountSessionStateProvider>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
const SessionStatePersisterInner = () => {
  usePersistSessionState();
  return null;
};
type AccountSessionState = {
  lastVisitedUrl: string | null;
  updateLastVisitedUrl: (url: string) => void;
};
const AccountSessionStateContext = React.createContext<AccountSessionState | null>(null);
export const useAccountSessionState = () => {
  const context = React.useContext(AccountSessionStateContext);
  if (!context) {
    throw new Error(`useAccountSessionState must be used within a ${AccountSessionStateProvider.name}`);
  }
  return context;
};
export const AccountSessionStateProvider = t0 => {
  const $ = _c(10);
  const {
    children
  } = t0;
  const [lastVisitedUrl, setLastVisitedUrl] = useLastVisitedUrlState();
  let t1;
  if ($[0] !== setLastVisitedUrl) {
    t1 = url => {
      setLastVisitedUrl(url);
    };
    $[0] = setLastVisitedUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const updateLastVisitedUrl = t1;
  let t2;
  if ($[2] !== updateLastVisitedUrl) {
    t2 = url_0 => updateLastVisitedUrl(url_0);
    $[2] = updateLastVisitedUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== lastVisitedUrl || $[5] !== t2) {
    t3 = {
      lastVisitedUrl,
      updateLastVisitedUrl: t2
    };
    $[4] = lastVisitedUrl;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children || $[8] !== t3) {
    t4 = <AccountSessionStateContext.Provider value={t3}>{children}</AccountSessionStateContext.Provider>;
    $[7] = children;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
const useLastVisitedUrlState = (): [string | null, (url: string) => void] => {
  const [lastVisitedUrl, setLastVisitedUrl] = useState<string | null>(null);
  useEffect(() => {
    const storedCookieValue = document.cookie.split("; ").find(row => row.startsWith(LAST_VISITED_URL_KEY));
    if (storedCookieValue) {
      const defaultValue = storedCookieValue.split("=")[1] ?? null;
      setLastVisitedUrl(defaultValue);
    }
  }, []);
  const mutation = api.accountSession.updateAccountSession.useMutation();
  const updateLastVisitedUrl = useCallback((url: string) => {
    if (url === "/ms-teams-poc") {
      return;
    }
    setLastVisitedUrl(url);
    document.cookie = `${LAST_VISITED_URL_KEY}=${url}; path=/; SameSite=None; Secure;`;
    mutation.mutate({
      lastVisitedUrl: url
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return [lastVisitedUrl, updateLastVisitedUrl];
};